{ "columns":0,
 "grid":
    {
     "height":1,
     "orientation":"orthogonal",
     "width":1
    },
 "margin":0,
 "name":"vmenezio",
 "spacing":0,
 "tilecount":80,
 "tiledversion":"1.8.6",
 "tileheight":16,
 "tiles":[
        {
         "id":0,
         "image":"vmenezio\/Layer 0.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":1,
         "image":"vmenezio\/Layer 1.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":2,
         "image":"vmenezio\/Layer 2.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":3,
         "image":"vmenezio\/Layer 3.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":4,
         "image":"vmenezio\/Layer 4.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":5,
         "image":"vmenezio\/Layer 5.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":6,
         "image":"vmenezio\/Layer 6.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":7,
         "image":"vmenezio\/Layer 7.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":8,
         "image":"vmenezio\/Layer 8.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":9,
         "image":"vmenezio\/Layer 9.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":10,
         "image":"vmenezio\/Layer 10.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":11,
         "image":"vmenezio\/Layer 11.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":12,
         "image":"vmenezio\/Layer 12.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":13,
         "image":"vmenezio\/Layer 13.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":14,
         "image":"vmenezio\/Layer 14.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":15,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_1.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":16,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_2.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":17,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_3.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":18,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_4.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":19,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_5.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":20,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_6.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":21,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_7.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":22,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_8.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":23,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_9.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":24,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_10.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":25,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_11.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":26,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_12.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":27,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_13.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":28,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_14.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":29,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_15.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":30,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_16.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":31,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_17.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":32,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_18.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":33,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_19.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":34,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_20.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":35,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_1.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":36,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_2.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":37,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_3.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":38,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_4.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":39,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_5.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":40,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_6.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":41,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_7.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":42,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_8.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":43,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_9.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":44,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_10.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":45,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_11.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":46,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_12.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":47,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_13.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":48,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_14.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":49,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_15.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":59,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/objects\/fort_blue.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":60,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/objects\/fort_red.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":61,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/objects\/house.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":62,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/objects\/mountain_1.png",
         "imageheight":16,
         "imagewidth":16,
         "properties":[
                {
                 "name":"hasCollision",
                 "type":"bool",
                 "value":true
                }]
        }, 
        {
         "id":63,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/objects\/mountain_2.png",
         "imageheight":16,
         "imagewidth":16,
         "properties":[
                {
                 "name":"hasCollision",
                 "type":"bool",
                 "value":true
                }]
        }, 
        {
         "id":64,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/objects\/tree_1.png",
         "imageheight":16,
         "imagewidth":16,
         "properties":[
                {
                 "name":"isTree",
                 "type":"bool",
                 "value":true
                }]
        }, 
        {
         "id":65,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/objects\/tree_2.png",
         "imageheight":16,
         "imagewidth":16,
         "properties":[
                {
                 "name":"isTree",
                 "type":"bool",
                 "value":true
                }]
        }, 
        {
         "id":66,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/desert\/objects\/bones_1.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":67,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/desert\/objects\/bones_2.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":68,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/desert\/objects\/cactus_1.png",
         "imageheight":16,
         "imagewidth":16,
         "properties":[
                {
                 "name":"isCactus",
                 "type":"bool",
                 "value":true
                }]
        }, 
        {
         "id":69,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/desert\/objects\/cactus_2.png",
         "imageheight":16,
         "imagewidth":16,
         "properties":[
                {
                 "name":"isCactus",
                 "type":"bool",
                 "value":true
                }]
        }, 
        {
         "id":70,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/desert\/objects\/rocks_1.png",
         "imageheight":16,
         "imagewidth":16,
         "properties":[
                {
                 "name":"hasCollision",
                 "type":"bool",
                 "value":true
                }]
        }, 
        {
         "id":71,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/desert\/objects\/rocks_2.png",
         "imageheight":16,
         "imagewidth":16,
         "properties":[
                {
                 "name":"hasCollision",
                 "type":"bool",
                 "value":true
                }]
        }, 
        {
         "id":72,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/desert\/objects\/rocks_3.png",
         "imageheight":16,
         "imagewidth":16,
         "properties":[
                {
                 "name":"hasCollision",
                 "type":"bool",
                 "value":true
                }]
        }, 
        {
         "id":73,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/desert\/objects\/tent_blue.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":74,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/desert\/objects\/tent_red.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":75,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_21.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":76,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_22.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":77,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_23.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":78,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_24.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":79,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_25.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":80,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_26.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":81,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_27.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":82,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_28.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":83,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_29.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":84,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_30.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":85,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_31.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":86,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_32.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":87,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/river\/river_33.png",
         "imageheight":16,
         "imagewidth":16
        }, 
        {
         "id":88,
         "image":"..\/..\/assets\/images\/hero-tactics\/map\/grasslands\/tilemaps\/road\/road_16.png",
         "imageheight":16,
         "imagewidth":16
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.8"
}